// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"345b39d5","51":"b8253dbe","318":"a1d947b5","509":"a7a794ff","617":"408bb09f","950":"f95d4c0f"}[chunkId] + ".chunk.js";
};